import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/commonFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields, purchasedMaterialFields } from './common/productFields';

import { msg } from '@lingui/core/macro';
import { expenditureFields } from './common/expenditureFields';

export const expenditureMetadata = {
  displayName: msg({
    message: 'Expenses',
    context: 'Activity data schema name for expenditure',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...purchasedMaterialFields,
    ...expenditureFields,
  },
} as const satisfies BatMetadataConfigEntry;
